import React, { useState } from "react";
import { Lock, ArrowRight } from "lucide-react";
import { captureLead } from "../lib/api";
import { toast } from "sonner";

const TEASER_IMG = "https://static.prod-images.emergentagent.com/jobs/fb9fd2e1-2adb-4004-a2e3-30c81c735602/images/8b68293efa1cab1b40dbf3d8dad741e372bb7b3d85fb50a2b02ddcdc89dfa225.png";

export default function LockedMapTeaser({ decisionId }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email.");
      return;
    }
    setSubmitting(true);
    try {
      await captureLead({ email, decision_id: decisionId, source: "public_locked_map_teaser" });
      setDone(true);
      toast.success("Saved. We'll be in touch from the 1% Club.");
    } catch (err) {
      toast.error("Couldn't save right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="relative pisa-card overflow-hidden" data-testid="locked-map-teaser">
      {/* Image background */}
      <div className="relative h-56 md:h-72 w-full overflow-hidden">
        <img
          src={TEASER_IMG}
          alt="Founder Decision Map preview"
          className="w-full h-full object-cover blur-[2px] scale-105"
        />
        <div className="absolute inset-0 pisa-lock-overlay" />
        <div className="absolute top-5 left-5 flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 border border-[#E5E5E5] shadow-sm">
          <Lock className="h-3.5 w-3.5 text-[#1A1A1A]" />
          <span className="text-xs uppercase tracking-[0.18em] text-[#1A1A1A]">Members only</span>
        </div>
      </div>

      <div className="p-8 md:p-10 -mt-12 relative">
        <div className="bg-white rounded-2xl border border-[#E5E5E5] p-7 md:p-9 shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
          <p className="text-xs uppercase tracking-[0.2em] text-[#f4b847] mb-3">Founder Decision Map</p>
          <h3 className="text-2xl md:text-3xl text-[#1A1A1A] font-medium tracking-tight mb-3">
            Track how your judgment grows across real decisions.
          </h3>
          <p className="text-[#666666] leading-relaxed mb-6 max-w-2xl">
            Inside the 1% Club, your decisions connect over time. Recurring patterns,
            repeated power misreads, bias trends, alignment strengths — quietly visible.
            Founder First; Business Second. This is where that gets practical.
          </p>

          {!done ? (
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl" data-testid="join-form">
              <input
                type="email"
                placeholder="you@founder.email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-5 py-3 rounded-full border border-[#E5E5E5] bg-[#F9F9F7] focus:outline-none focus:ring-2 focus:ring-[#2596be]/20 focus:border-[#2596be] transition-all text-[#1A1A1A]"
                data-testid="join-email-input"
              />
              <button
                type="submit"
                disabled={submitting}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#2596be] text-white font-medium hover:bg-[#1E7D9F] transition-colors disabled:opacity-60"
                data-testid="join-submit-btn"
              >
                {submitting ? "Saving…" : "Unlock the Founder Decision Map"}
                <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          ) : (
            <div className="px-5 py-4 rounded-2xl bg-[#2596be]/8 border border-[#2596be]/20 text-[#1A1A1A]" data-testid="join-success">
              You're on the list. We'll reach out from the 1% Club shortly.
            </div>
          )}
          <p className="text-xs text-[#666666] mt-4">Continue inside the 1% Club · No spam, ever.</p>
        </div>
      </div>
    </section>
  );
}
